import React from 'react';
import MDCockpit from './md-ai/MDCockpit';

const Modelling: React.FC = () => {
  return <MDCockpit />;
};

export default Modelling;
